export function organization() {
  return {
    "@type": "Organization",
    "@id": "https://www.roamdoc.com/#Organization",
    name: "Roamdoc",
    url: "https://www.roamdoc.com",
    description: "Job search engine for physicians in anesthesiology.",
    image: "https://www.roamdoc.com/roamdoc-logo.png",
    email: "hello@roamdoc.com",
    sameAs: [
      "https://www.linkedin.com/company/roamdoc",
      "https://www.facebook.com/roamdoc",
      "https://www.youtube.com/@roamdoc",
      "https://www.instagram.com/roamdoc",
      "https://www.twitter.com/roamdoc",
    ],
    founder: fmPerson(),
    contactPoint: {
      "@type": "ContactPoint",
      email: "hello@roamdoc.com",
    },
  };
}

export function website() {
  return {
    "@type": "WebSite",
    "@id": "https://www.roamdoc.com/#WebSite",
    url: "https://www.roamdoc.com",
    name: "Roamdoc",
    description: "Job search engine for physicians in anesthesiology.",
    publisher: organization(),
  };
}

export function fmPerson() {
  return {
    "@type": "Person",
    "@id": "#frank-melo-md",
    name: "Frank Melo, MD",
    url: "https://www.roamdoc.com/about-roamdoc/frank-melo-md",
    alternativeName: "Dr. Francisco J. Melo",
    additionalName: [
      "Frank Melo",
      "Francisco Melo",
      "Francisco J Melo",
      "Dr. Francisco J Melo",
    ],
    sameAs: [
      "https://www.linkedin.com/in/frank-melo",
      "https://www.vitals.com/doctors/Dr_Frank_Melo.html",
      "https://www.md.com/doctor/francisco-melo-md",
      "https://www.doximity.com/pub/francisco-melo-md",
      "https://health.usnews.com/doctors/francisco-melo-398645",
      "https://www.docspot.com/p/francisco-j-melo",
      "https://www.docinfo.org/search/docprofile?docid=FBF174A3-29D2-42A4-A37A-5AC32069B073",
      "https://healthcare4ppl.com/physician/arizona/fort-mohave/francisco-j-melo-1316980758.html",
      "https://npidb.org/doctors/allopathic_osteopathic_physicians/anesthesiology_207l00000x/1316980758.aspx",
      "https://health.usnews.com/doctors/francisco-melo-398645",
      "https://www.healthgrades.com/physician/dr-francisco-melo-y632b",
      "https://www.sharecare.com/doctor/dr-francisco-j-melo",
      "https://doctor.webmd.com/doctor/francisco-melo-2989b424-dec5-11e7-9f4c-005056a225bf-overview",
      "https://www.healthcare6.com/physician/chinle-az/francisco-j-melo-345038.html",
    ],
    description: "Physician in anesthesiology.",
    image: "https://www.roamdoc.com/frank-melo-md.png",
    alumniOf: [
      {
        "@type": "EducationalOrganization",
        name: "New York Methodist Hospital",
        description: "Residency",
        url: "https://www.nyp.org/brooklyn/medical-education/residency/anesthesiology",
      },
      {
        "@type": "EducationalOrganization",
        name: "New York Medical College",
        description: "Specialized Cardiac Fellowship",
        url: "https://metanesthesiology.com",
      },
    ],
    interactionStatistic: [
      {
        "@type": "InteractionCounter",
        interactionType: "https://schema.org/WriteAction",
        userInteractionCount: 6,
      },
    ],
    knowsLanguage: [
      {
        "@type": "Language",
        name: "English",
        alternateName: "en",
      },
      {
        "@type": "Language",
        name: "Spanish",
        alternateName: "es",
      },
    ],
    knowsAbout: [
      {
        "@type": "Thing",
        name: "general anaesthesia",
        sameAs: "https://www.wikidata.org/wiki/Q166543",
      },
      {
        "@type": "Thing",
        name: "anaesthesiology",
        sameAs: "https://www.wikidata.org/wiki/Q615057",
      },
      {
        "@type": "Thing",
        name: "anesthesiologist",
        sameAs: "https://www.wikidata.org/wiki/Q28837",
      },
      {
        "@type": "Thing",
        name: "physician",
        sameAs: "https://www.wikidata.org/wiki/Q39631",
      },
      {
        "@type": "Thing",
        name: "recruitment",
        sameAs: "https://www.wikidata.org/wiki/Q899277",
      },
      {
        "@type": "Thing",
        name: "locum",
        sameAs: "https://www.wikidata.org/wiki/Q100329140",
      },
    ],
  };
}
